import React from "react";
import { Box } from "@chakra-ui/react";

function BlueDot() {
  return (
    <Box
      borderRadius={"100%"}
      bg={"primary"}
      w={"30px"}
      h={"30px"}
      mr={"10px"}
    ></Box>
  );
}

export default BlueDot;
